import * as firebase from "firebase";

export const batchUpdate = async (collectionName: string, itemsToUpdate: any[]) => {
  try {
    console.log(`collection: ${collectionName} | itemsToUpdate.length: ${itemsToUpdate.length}`);

    const batchSize = 500;
    let documentCount = 0;

    const batchedUpdates = itemsToUpdate.reduce((batches, item) => {
      const documentRef = firebase.firestore().collection(collectionName).doc(item.docId);
      const docUpdates = item.updates;

      if (documentCount % batchSize === 0) {
        batches.push([]);
      }

      batches[batches.length - 1].push({ ref: documentRef, updates: docUpdates });
      documentCount++;

      return batches;
    }, [[]]);

    for (const batch of batchedUpdates) {
      const batchUpdates = batch.map((update) => ({
        ref: update.ref,
        data: update.updates,
      }));

      console.log('batch.update()');
      try {
        await firebase.firestore().runTransaction(async (transaction) => {
          for (const update of batchUpdates) {
            transaction.update(update.ref, update.data);
          }
        });
        console.log(`Batch ${documentCount} / ${batchSize} completed successfully.`);
      } catch (error) {
        console.error(`Error while performing batch ${Math.ceil(documentCount / batchSize)}:`, error);
        return {
          status: 500,
          code: 'Failed',
        };
      }
    }

    console.log('done');

    return {
      status: 200,
      code: 'Success',
    };

  } catch (error) {
    console.error('Error:', error);
    return {
      message: 'Unhandled Exception',
      status: 500,
      code: 'Failed',
    };
  }
};


